import { render } from "./exportFilePdf.vue?vue&type=template&id=23a7c435"
import script from "./exportFilePdf.vue?vue&type=script&lang=js"
export * from "./exportFilePdf.vue?vue&type=script&lang=js"

import exportComponent from "/Users/charcoaldev/Documents/GitHub/beardrug-pos/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__